import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const CurrencyContractor = () => {
  return (
    <SettingsMetaData propertyName={"Currency_Contractor"} viewPropertyName={"Currency"} />
  );
};
export default CurrencyContractor;